@if (isNewAgent) {
<div class="my-2">
  <mwp-text-translate text="To create a new agent profile, please fill out the information below and click save." jsonKey="agentFormNote" />
</div>
}
<div class="content-container">
  <div class="title d-inline-flex w-100">
    <mwp-text-translate [text]="formTitle" [jsonKey]="formTitle" />
  </div>
  <div class="content  mb-3">
    @if (displayForm) {
    <form [formGroup]="agentForm">
      <div class="row">
        <!-- <div class="col-12 p-3 mb-4"></div> SELECT BROKER DROPDOWN GOES IN THIS DIV -->
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="First Name" nameForControl="firstName" />
        </div>
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="Middle Name" nameForControl="middleName" />
        </div>
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="Last Name" nameForControl="lastName" />
        </div>
        @if (!this.isNewAgent) {
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="User ID" nameForControl="uid" />
        </div>
        }
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="Email" nameForControl="email" />
        </div>
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="Address" nameForControl="address" />
        </div>
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="City" nameForControl="city" />
        </div>
        <div class="col-3 mb-4">
          <mwp-dropdown-enum [form]="agentForm" labelName="State" nameForControl="state" [dataEnum]="usStates" [autoTranslate]="true" />
        </div>
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="Zip Code" [maskType]="maskType.zipCode" nameForControl="zipCode" />
        </div>
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="Phone" [maskType]="maskType.phone" nameForControl="phone" />
        </div>
        <div class="col-3 mb-4">
          <mwp-input [form]="agentForm" labelName="Fax" [maskType]="maskType.phone" nameForControl="fax" />
        </div>
        <div class="col-3 mb-3 px-3">
          <label class="label-alt">
            <mwp-text-translate text="Agent Type" jsonKey="agentType" />
          </label>
          <div>
            @if (!hasAccessToAllBrokers) {
            <mwp-radio-button [form]="agentForm" nameForControl="type" [dataEnum]="agentType" />
            }
            @if (hasAccessToAllBrokers) {
            <mwp-radio-button [form]="agentForm" nameForControl="type" [dataEnum]="hgsAgentType" />
            }
          </div>
        </div>
        @if (!isNewAgent) {
        <div class="col-3 mb-4">
          <label class="label-alt pb-3">
            <mwp-text-translate text="Generate New Password And Send Verification Email To Agent" jsonKey="agentFormGenerateReset" />
          </label>
          <div class="d-flex align-items-center">
            <button class="mwp-button-delete col-12 me-3" (click)="resetPassword()">
              <mwp-text-translate text="Reset Password" jsonKey="resetPassword" />
            </button>
          </div>
        </div>
        <div class="col-3 d-flex align-items-center">
          <mat-checkbox formControlName="resetPassword">
            <label class="label-alt">
              <mwp-text-translate text="Require Agent To Reset Password On Next Login" jsonKey="agentFormRequireReset" />
            </label>
          </mat-checkbox>
        </div>
        }
      </div>
    </form>
    }
    @if (displayForm) {
    <div class="d-inline-flex justify-content-end w-100 p-3">
      <button class="mwp-button-secondary me-3" (click)="back()">
        <mwp-text-translate text="Cancel" jsonKey="cancel" />
      </button>
      <button class="mwp-button-save" [disabled]="!agentForm.valid" (click)="saveAgent()">
        {{ saveButtonText }}
      </button>
    </div>
    }
  </div>
</div>